module.exports = __webpack_public_path__ + "img/IMG_3450_L_WoodMatted.a78df618.jpg";